import { Dispatch, SetStateAction, useState } from 'react';

/**
 * State the user changes that starts over when `resetKey` changes (e.g.
 * another record is shown). It resets during render, so nothing renders with
 * the previous record's state, unlike resetting it in an effect.
 */
export function useResettableState<T>(
  resetKey: unknown,
  createInitialState: () => T
): [T, Dispatch<SetStateAction<T>>] {
  const [state, setState] = useState(createInitialState);
  const [stateResetKey, setStateResetKey] = useState(resetKey);

  if (!Object.is(stateResetKey, resetKey)) {
    const initialState = createInitialState();
    setStateResetKey(resetKey);
    setState(initialState);
    return [initialState, setState];
  }
  return [state, setState];
}
